import React from 'react';
import Layout from '../../../components/common/pageLayout';
import Form from '../../../components/MasterData/EventType/add';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import { v3_add_event_type } from '../../../actions/v3/masterData';

const AddCategory = (props) => {
    const onSubmit = (model) => {
        v3_add_event_type(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message);
                props.history.push(constant.Authedcomponent.listCategoryEventMasterData.url);
            } else {
                toast.error(res.error);
            }
        });
    };

    return (
        <React.Fragment>
            <Layout title="Add Event">
                <Form
                    title="Add Event"
                    onSubmit={onSubmit}
                    buttonName="Create Event"
                />
            </Layout>
        </React.Fragment>
    );
};

export default AddCategory;
